import { Component, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { HttpClient } from '@angular/common/http'
import { environment } from 'environments/environment'
import { AuthService } from '../../_services'
import { LoaderService } from '../../_services/loader.service'
import { process, State, aggregateBy } from '@progress/kendo-data-query'
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query'
import { Observable } from 'rxjs/Observable'
import {
  SelectableSettings,
  DataStateChangeEvent,
  GridDataResult,
} from '@progress/kendo-angular-grid'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'
import * as _moment from 'moment'
import * as _rollupMoment from 'moment'
const moment = _rollupMoment || _moment
import { utils, write, WorkBook } from 'xlsx'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import Swal from 'sweetalert2'

declare var $: any
const distinctPurchase = (data) =>
  data.filter(
    (x, idx, xs) =>
      xs.findIndex((y) => y.PURCHASETYPE === x.PURCHASETYPE) === idx,
  )
const distinctZone = (data) =>
  data.filter((x, idx, xs) => xs.findIndex((y) => y.Zone === x.Zone) === idx)

const distinctWard = (data) =>
  data.filter((x, idx, xs) => xs.findIndex((y) => y.ward === x.ward) === idx)
const distinctGivenTo = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.GIVENTO === x.GIVENTO) === idx,
  )

const distinctVehCategory = (data) =>
  data.filter(
    (x, idx, xs) => xs.findIndex((y) => y.vehcatName === x.vehcatName) === idx,
  )

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'fuelMaster',
  templateUrl: './fuelMaster.component.html',
})
export class FuelMasterReportComponent {
  public pData = [
    { months: 'January', value: 10 },
    { months: 'February', value: 20 },
    { months: 'March', value: 30 },
    { months: 'April', value: 10 },
    { months: 'May', value: 20 },
    { months: 'June', value: 30 },
    { months: 'July', value: 10 },
    { months: 'August', value: 20 },
    { months: 'September', value: 30 },
    { months: 'October', value: 10 },
    { months: 'November ', value: 20 },
    { months: 'December', value: 30 },
  ]

  public lData = [
    { months: 'January', value: 10 },
    { months: 'February', value: 20 },
    { months: 'March', value: 30 },
    { months: 'April', value: 10 },
    { months: 'May', value: 20 },
    { months: 'June', value: 30 },
    { months: 'July', value: 10 },
    { months: 'August', value: 20 },
    { months: 'September', value: 30 },
    { months: 'October', value: 10 },
    { months: 'November ', value: 20 },
    { months: 'December', value: 30 },
  ]

  public dData = [
    { months: 'January', value: 10 },
    { months: 'February', value: 20 },
    { months: 'March', value: 30 },
    { months: 'April', value: 10 },
    { months: 'May', value: 20 },
    { months: 'June', value: 30 },
    { months: 'July', value: 10 },
    { months: 'August', value: 20 },
    { months: 'September', value: 30 },
    { months: 'October', value: 10 },
    { months: 'November ', value: 20 },
    { months: 'December', value: 30 },
  ]

  prjId: any
  showLoader: boolean
  startDate: any
  endDate: any
  defStartDt: any
  defEndDt: any
  dateRange: any
  fuelReportList: any
  purchaseImg: any
  fuelAmnt: any
  fuelQty: any
  rowCount: any
  public state: State = {
    skip: 0,
    take: 16,
    filter: {
      logic: 'and',
      filters: [],
    },
  }
  public pageSize: any
  public checkboxOnly = false
  public mode = 'multiple'
  public selectableSettings: SelectableSettings
  public masterdata: any
  gridDatamaster: DataResult
  vehcilePurchased: any
  loosePurchased: any
  fuelDistributed: any
  totalPur: any
  fuleGraphdata: { category: string; value: number }[]
  FuelGraphicleView: any
  PurchaseMonthwiseFuledata: any[]
  DistributeMonthwiseFuledata: any[]
  defaultStartDate: string
  start: string
  end: string
  purchsedata: any
  distributedata: any
  LoosePurchaseMonthwiseFuledata: any
  LoosePurchaseMonthwiseData: any[]
  VehicleWiseFuelConsumption: Object
  zoneWiseDistDataForGraph: any[]

  zoneWisePurcheDataForGraph: any[]
  FrequentFuelConsumptionData: any
  newFuelConsumption: Object
  selectedStartsDate: any
  selectedEndDate: any
  yearsModal: any
  monthsmodal: any
  blockTemp: any
  currentMonth: any
  firstDay: Date
  topTenFrequentFuelConsumptionData: any[]
  fuelDistList: Object
  contentTypeToShow: string
  primeValue: any
  primeChevckMonths: boolean
  primeChevckDays: boolean

  YearDistributeFuledata: any[]
  YearPurchaseFuledata: any[]
  YearLooseFuledata: any[]

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.masterdata,
    }
    return result
  }

  public groups: GroupDescriptor[] = []
  public view: Observable<GridDataResult>

  public gridDataFuelReport: DataResult
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups
    this.loadProducts()
  }

  public distinctPurchase: any[]
  public distinctVehCategory: any[]
  public distinctZone: any[]
  public distinctWard: any[]
  public distinctVehType: any[]
  public distinctGivenTo: any[]
  loaderClass: any
  syncing: any
  private loadProducts(): void {
    this.gridDataFuelReport = process(this.fuelReportList, {
      group: this.groups,
    })
  }
  constructor(
    private http: HttpClient,
    private auth: AuthService,
    public routes: ActivatedRoute,
    public router: Router,
    private loaderService: LoaderService,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
    this.allData = this.allData.bind(this)
    this.vehcilePurchased = 0
    this.loosePurchased = 0
    this.fuelDistributed = 0

    this.totalPur = 0
    var date = new Date()
    this.defStartDt =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    this.defEndDt =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()

    //this.defEndDt = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate();

    this.dateRange = {
      beginDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
      endDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    }
    this.fuelAmnt = 0
    this.fuelQty = 0
    this.rowCount = 0
    this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1)

    this.defaultStartDate =
      this.firstDay.getFullYear() +
      '-' +
      (this.firstDay.getMonth() + 1) +
      '-' +
      this.firstDay.getDate()
    this.currentMonth = moment().format('MMMM')

    this.primeChevckDays = false

    this.primeChevckMonths = false
  }

  ngOnInit() {
    this.blockTemp = false

    this.selectedStartsDate = moment(this.defaultStartDate).format('YYYY-MM-DD')

    // this.endDate = moment(this.defEndDt).format('YYYY-MM-DD');

    var years = moment(this.defaultStartDate).format('YYYY')

    var month = moment(this.defaultStartDate).format('MM')

    // console.log('this.startDate 202' ,years ,'this.endDate 202',month);

    this.prjId = this.auth.getAuthentication().projectId

    this.getYearlyMonthsWisefuelDetails()

    var lastday = function (y, m) {
      return new Date(y, m, 0).getDate()
    }

    this.selectedEndDate = years + '-' + month + '-' + lastday(years, month)

    // console.log('this.selectedEndDate 225',this.selectedEndDate);

    this.dateWiseApiCalls(this.selectedStartsDate, this.selectedEndDate)
  }

  dateWiseApiCalls(startDate, endDate) {
    console.log('281', startDate, endDate, this.firstDay)

    console.log(
      '281',
      this.firstDay.getFullYear(),
      this.firstDay.getMonth() + 1,
    )

    //(this.firstDay.getMonth()+1>5) &&

    if (this.firstDay.getFullYear() >= 2022) {
      this.contentTypeToShow = 'new'
      this.newVersionAPIS(startDate, endDate)
    } else {
      console.log('days old')

      this.contentTypeToShow = 'old'
      this.oldVersionAPIS(startDate, endDate)
    }
  }

  oldVersionAPIS(startDate, endDate) {
    this.getFuelMasterRepoerList(startDate, endDate)

    this.getDistributeMonthwiseFuledata(startDate, endDate)

    this.getVehicleWiseFuelConsumption(startDate, endDate)

    this.getFrequentFuelConsumption(startDate, endDate)

    //  report
  }
  newVersionAPIS(startDate, endDate) {
    this.getNewFuelMasterReport(startDate, endDate)
    this.getNewPuechaseDistributeMonthWiseDate(startDate, endDate)
    this.getNewVehicleWiseFuelConsumption(startDate, endDate)
    this.getNewFrequentFuelConsumption(startDate, endDate)
  }

  getFuelMasterRepoerList(startdate, endDate) {
    this.loaderService.display(true)
    console.log(this.prjId)
    // api to get all master data start
    this.http
      .get(
        environment.apiUrl +
          'reports/getFuelmasterReport?prjid=' +
          this.prjId +
          '&startDate=' +
          startdate +
          '&endDate=' +
          endDate,
      )
      .subscribe((data) => {
        this.masterdata = data

        if (this.masterdata.length > 0) {
          this.vehcilePurchased = 0
          this.loosePurchased = 0
          this.fuelDistributed = 0

          this.getZoneWisegraphDataFun(this.masterdata)

          for (let index = 0; index < this.masterdata.length; index++) {
            if (this.masterdata[index].PURCHASETYPE == 'Vehicle') {
              this.vehcilePurchased += this.masterdata[index].QTY
            }
            if (this.masterdata[index].PURCHASETYPE == 'Loose') {
              this.loosePurchased += this.masterdata[index].QTY
            }
            if (this.masterdata[index].PURCHASETYPE == 'Distributed') {
              this.fuelDistributed += this.masterdata[index].QTY
            }
          }

          console.log('this.loosePurchased type', typeof this.loosePurchased)

          this.FuelGraphicleView = [
            {
              purchase_for: 'Vehicle Purchased',
              QTY: this.vehcilePurchased.toFixed(2),
            },
            {
              purchase_for: 'Loose Purchased',
              QTY: this.loosePurchased.toFixed(2),
            },
            {
              purchase_for: 'Fuel Distributed',
              QTY: this.fuelDistributed.toFixed(2),
            },
          ]

          console.log('	this.FuelGraphicleView ', this.FuelGraphicleView)

          //this.distinctLocation = distinctLocation(this.fuelDistList)
          //this.distinctFuelType = distinctFuelType(this.fuelDistList)
          // this.distinctVehCategory = distinctVehCategory(this.masterdata);
          // this.distinctZone = distinctZone(this.masterdata)
          // this.distinctWard = distinctWard(this.masterdata)
          // this.distinctGivenTo = distinctGivenTo(this.masterdata)
          // this.distinctPurchase = distinctPurchase(this.masterdata)
          // this.gridDatamaster = process(this.masterdata, this.state);
          this.loaderService.display(false)
        } else {
          this.loaderService.display(false)
          this.gridDatamaster = null
        }
      })

    //   api to get all master data start
  }

  getNewFuelMasterReport(startdate, endDate) {
    this.http
      .get(
        environment.apiUrl +
          'reports/getNewFuelMasterReport?prjid=' +
          this.prjId +
          '&startDate=' +
          startdate +
          '&endDate=' +
          endDate,
      )
      .subscribe((data) => {
        this.masterdata = data
        this.getZoneWisegraphDataFun(this.masterdata)
        this.vehcilePurchased = 0.0
        this.loosePurchased = 0.0
        this.fuelDistributed = 0.0
        if (this.masterdata.length > 0) {
          for (let index = 0; index < this.masterdata.length; index++) {
            if (this.masterdata[index].PURCHASETYPE == 'Vehicle') {
              //   this.vehcilePurchased += Math.round(this.masterdata[index].QTY)
              this.vehcilePurchased += Number(this.masterdata[index].QTY)
            }

            if (this.masterdata[index].PURCHASETYPE == 'Loose') {
              //   this.loosePurchased += Math.round(this.masterdata[index].QTY)
              this.loosePurchased += Number(this.masterdata[index].QTY)
            }

            if (this.masterdata[index].PURCHASETYPE == 'Distributed') {
              //   this.fuelDistributed += Math.round(this.masterdata[index].QTY)
              this.fuelDistributed += Number(this.masterdata[index].QTY)
            }
          }

          console.log('this.loosePurchased type', typeof this.loosePurchased)

          this.FuelGraphicleView = [
            { purchase_for: 'Vehicle Purchased', QTY: this.vehcilePurchased },
            { purchase_for: 'Loose Purchased', QTY: this.loosePurchased },
            { purchase_for: 'Fuel Distributed', QTY: this.fuelDistributed },
          ]

          console.log('new', this.FuelGraphicleView)

          this.loaderService.display(false)
        } else {
          this.loaderService.display(false)
          this.gridDatamaster = null
          this.FuelGraphicleView = []
        }
        console.log('vehcilePurchased', this.vehcilePurchased)
      })
  }

  getZoneWisegraphDataFun(data) {
    this.zoneWiseDistDataForGraph = [
      { category: 'Zone_1', value: 0 },
      { category: 'Zone_2', value: 0 },
      { category: 'Zone_3', value: 0 },
      { category: 'Zone_4', value: 0 },
      { category: 'NA', value: 0 },
    ]

    this.zoneWisePurcheDataForGraph = [
      { category: 'Zone_1', value: 0 },
      { category: 'Zone_2', value: 0 },
      { category: 'Zone_3', value: 0 },
      { category: 'Zone_4', value: 0 },
      { category: 'NA', value: 0 },
    ]

    if (data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        if (
          data[index].PURCHASETYPE == 'Loose' ||
          data[index].PURCHASETYPE == 'Vehicle'
        ) {
          if (data[index].Zone == 'ZONE-1') {
            this.zoneWisePurcheDataForGraph[0]['value'] += Math.round(
              data[index].QTY,
            )
          }
          if (data[index].Zone == 'ZONE-2') {
            this.zoneWisePurcheDataForGraph[1]['value'] += Math.round(
              data[index].QTY,
            )
          }
          if (data[index].Zone == 'ZONE-3') {
            this.zoneWisePurcheDataForGraph[2]['value'] += Math.round(
              data[index].QTY,
            )
          }
          if (data[index].Zone == 'ZONE-4') {
            this.zoneWisePurcheDataForGraph[3]['value'] += Math.round(
              data[index].QTY,
            )
          }
          if (data[index].Zone == null) {
            this.zoneWisePurcheDataForGraph[4]['value'] += Math.round(
              data[index].QTY,
            )
          }
        }

        if (data[index].PURCHASETYPE == 'Distributed') {
          if (data[index].Zone == 'ZONE-1') {
            this.zoneWiseDistDataForGraph[0]['value'] += Math.round(
              data[index].QTY,
            )
          }
          if (data[index].Zone == 'ZONE-2') {
            this.zoneWiseDistDataForGraph[1]['value'] += Math.round(
              data[index].QTY,
            )
          }
          if (data[index].Zone == 'ZONE-3') {
            this.zoneWiseDistDataForGraph[2]['value'] += Math.round(
              data[index].QTY,
            )
          }
          if (data[index].Zone == 'ZONE-4') {
            this.zoneWiseDistDataForGraph[3]['value'] += Math.round(
              data[index].QTY,
            )
          }
          if (data[index].Zone == null) {
            this.zoneWiseDistDataForGraph[4]['value'] += Math.round(
              data[index].QTY,
            )
          }
        }
      }
    }
  }

  //// excell down load data

  importVehiclesExcelReport(data) {
    console.log('504', data)

    const ws_name = 'VehicleReport'
    const wb: WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = utils.json_to_sheet(data)
    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary',
    })
    saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      'exported.xlsx',
    )
  }

  s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff
    }
    return buf
  }

  getallMasterReport() {
    this.importVehiclesExcelReport(this.masterdata)
  }

  onDateRangeChanged(dataRange) {
    if (dataRange.beginDate.day > 0) {
      this.startDate =
        dataRange.beginDate.year +
        '-' +
        dataRange.beginDate.month +
        '-' +
        dataRange.beginDate.day
      this.endDate =
        dataRange.endDate.year +
        '-' +
        dataRange.endDate.month +
        '-' +
        dataRange.endDate.day
      //this.getFuelMasterRepoerList(startdate ,endDate);
    } else if (dataRange.beginDate.day == 0) {
      this.startDate = this.defStartDt
      this.endDate = this.defEndDt
      //this.getFuelMasterRepoerList(startdate ,endDate);
    }
  }

  /*
   * filter The Grid Data
   */
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state
    //this.gridDataFuelDist = process(this.masterdata  , this.state);
    if (state && state.group) {
      this.distinctVehCategory = distinctVehCategory(this.masterdata)
      this.distinctZone = distinctZone(this.masterdata)
      this.distinctPurchase = distinctPurchase(this.masterdata)
      this.gridDatamaster = process(this.masterdata, this.state)
    }
  }

  getDistributeMonthwiseFuledata(startDate, endDate) {
    // this.startDate  = moment(this.defaultStartDate).format('YYYY-MM-DD');
    // this.endDate = moment(this.defEndDt).format('YYYY-MM-DD');

    this.http
      .get(
        environment.apiUrl +
          'reports/getDistributeMonthwiseFuledata?prjid=' +
          this.prjId +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate,
      )
      .subscribe((data) => {
        this.distributedata = data

        console.log('529', this.distributedata)

        this.DistributeMonthwiseFuledata = []
        this.LoosePurchaseMonthwiseData = []
        this.PurchaseMonthwiseFuledata = []

        for (let i = 0; i < this.distributedata.length; i++) {
          if (this.distributedata[i]['PURCHASETYPE'] == 'Distributed') {
            this.DistributeMonthwiseFuledata.push({
              dates: this.distributedata[i]['dates'],
              TOTALQYT: this.distributedata[i]['QTY'],
            })
          }
          if (this.distributedata[i]['PURCHASETYPE'] == 'Vehicle') {
            this.PurchaseMonthwiseFuledata.push({
              dates: this.distributedata[i]['dates'],
              TOTALQYT: this.distributedata[i]['QTY'],
            })
          }
          if (this.distributedata[i]['PURCHASETYPE'] == 'Loose') {
            this.LoosePurchaseMonthwiseData.push({
              dates: this.distributedata[i]['dates'],
              TOTALQYT: this.distributedata[i]['QTY'],
            })
          }
        }
      })
  }

  getNewPuechaseDistributeMonthWiseDate(startDate, endDate) {
    this.http
      .get(
        environment.apiUrl +
          'reports/getNewPuechaseDistributeMonthWiseDate?prjid=' +
          this.prjId +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate,
      )
      .subscribe((data) => {
        this.distributedata = data

        console.log('529', this.distributedata)

        this.DistributeMonthwiseFuledata = []
        this.LoosePurchaseMonthwiseData = []
        this.PurchaseMonthwiseFuledata = []

        for (let i = 0; i < this.distributedata.length; i++) {
          if (this.distributedata[i]['PURCHASETYPE'] == 'Distributed') {
            this.DistributeMonthwiseFuledata.push({
              dates: this.distributedata[i]['dates'],
              TOTALQYT: this.distributedata[i]['QTY'],
            })
          }
          if (this.distributedata[i]['PURCHASETYPE'] == 'Vehicle') {
            this.PurchaseMonthwiseFuledata.push({
              dates: this.distributedata[i]['dates'],
              TOTALQYT: this.distributedata[i]['QTY'],
            })
          }
          if (this.distributedata[i]['PURCHASETYPE'] == 'Loose') {
            this.LoosePurchaseMonthwiseData.push({
              dates: this.distributedata[i]['dates'],
              TOTALQYT: this.distributedata[i]['QTY'],
            })
          }
        }
      })
  }

  getVehicleWiseFuelConsumption(startDate, endDate) {
    this.http
      .get(
        environment.apiUrl +
          'reports/getVehicleWiseFuelConsumption?prjid=' +
          this.prjId +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate,
      )
      .subscribe((data) => {
        this.VehicleWiseFuelConsumption = data

        console.log('460', this.VehicleWiseFuelConsumption)
      })
  }

  getNewVehicleWiseFuelConsumption(startDate, endDate) {
    this.http
      .get(
        environment.apiUrl +
          'reports/getNewVehicleWiseFuelConsumption?prjid=' +
          this.prjId +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate,
      )
      .subscribe((data) => {
        this.VehicleWiseFuelConsumption = data

        console.log('460', this.VehicleWiseFuelConsumption)
      })
  }

  //

  getFrequentFuelConsumption(startdate, endDate) {
    this.http
      .get(
        environment.apiUrl +
          'reports/getFrequentFuelConsumption?prjid=' +
          this.prjId +
          '&startDate=' +
          startdate +
          '&endDate=' +
          endDate,
      )
      .subscribe((data) => {
        this.FrequentFuelConsumptionData = data

        this.topTenFrequentFuelConsumptionData = []

        for (let index = 0; index < 5; index++) {
          this.topTenFrequentFuelConsumptionData.push(
            this.FrequentFuelConsumptionData[index],
          )
        }

        console.log(
          'this.topTenFrequentFuelConsumptionData old',
          this.topTenFrequentFuelConsumptionData,
        )
      })
  }

  //

  getNewFrequentFuelConsumption(startdate, endDate) {
    this.http
      .get(
        environment.apiUrl +
          'reports/getNewFrequentFuelConsumption?prjid=' +
          this.prjId +
          '&startDate=' +
          startdate +
          '&endDate=' +
          endDate,
      )
      .subscribe((data) => {
        this.FrequentFuelConsumptionData = data

        this.topTenFrequentFuelConsumptionData = []

        for (let index = 0; index < 5; index++) {
          this.topTenFrequentFuelConsumptionData.push(
            this.FrequentFuelConsumptionData[index],
          )
        }

        console.log(
          'this.topTenFrequentFuelConsumptionData new',
          this.topTenFrequentFuelConsumptionData,
        )
      })
  }

  //  getAllFrequentFuelConsumption(){

  // 	this.http.get(environment.apiUrl + 'reports/getNewFrequentFuelConsumption?prjid='+this.prjId+'&startDate='+startdate+'&endDate='+endDate).subscribe(data=>{

  // 		this.FrequentFuelConsumptionData = data

  // 		console.log('589',this.FrequentFuelConsumptionData );

  //  })

  //  }

  changeYearsForGraph(e) {
    this.yearsModal = e.target.value

    console.log('this.yearsModal ', this.yearsModal)
    this.monthsmodal = null
  }

  changecDateForGraph(e) {
    console.log(this.blockTemp)

    var months = e.target.value

    var lastday = function (y, m) {
      return new Date(y, m, 0).getDate()
    }

    this.selectedStartsDate = this.yearsModal + '-' + months + '-01'

    this.selectedEndDate =
      this.yearsModal + '-' + months + '-' + lastday(this.yearsModal, months)

    this.currentMonth = moment(this.selectedStartsDate).format('MMMM')

    //months>5 && this.yearsModal >=2022

    if (this.yearsModal > 2022) {
      console.log(
        'this.selectedStartsDate,this.selectedEndDate',
        this.selectedStartsDate,
        this.selectedEndDate,
      )

      this.contentTypeToShow = 'new'
      this.newVersionAPIS(this.selectedStartsDate, this.selectedEndDate)
    } else {
      if (months <= 5 && this.yearsModal == 2022) {
        this.contentTypeToShow = 'old'
        this.oldVersionAPIS(this.selectedStartsDate, this.selectedEndDate)
      } else {
        this.contentTypeToShow = 'new'
        this.newVersionAPIS(this.selectedStartsDate, this.selectedEndDate)
      }
    }
  }

  // All reports Api

  //  type Purchse_Vehicle , Purchse_Loose

  fuelPurchasedVehicleORLooseReport(purchaseType, resultType) {
    console.log('filter data', purchaseType, resultType, this.contentTypeToShow)

    this.loaderService.display(true)
    this.http
      .get(
        environment.apiUrl +
          'reports/getFuelReportV2?prjid=' +
          this.prjId +
          '&purchaseType=' +
          purchaseType +
          '&startDate=' +
          this.selectedStartsDate +
          '&endDate=' +
          this.selectedEndDate +
          '&resultType=' +
          resultType +
          '&contentFor=' +
          this.contentTypeToShow,
      )
      .subscribe((data) => {
        this.fuelReportList = data
        this.importVehiclesExcelReport(data)
        this.loaderService.display(false)
      })
  }

  //  getFuelDistributionList(){
  // 	this.loaderService.display(true);
  // 		   this.http.get(environment.apiUrl + 'reports/getFuelDistributionReport?prjid='+this.prjId+'&startDate='+this.selectedStartsDate+'&endDate='+this.selectedEndDate).subscribe(data =>{
  // 		   this.fuelDistList=data;
  // 		   this.importVehiclesExcelReport(data)
  // 		   this.loaderService.display(false);
  // 	   });
  //  }

  getReportPurchaseAndDistribute() {
    this.loaderService.display(true)
    this.http
      .get(
        environment.apiUrl +
          'reports/getReportPurchaseAndDistribute?prjid=' +
          this.prjId +
          '&startDate=' +
          this.selectedStartsDate +
          '&endDate=' +
          this.selectedEndDate,
      )
      .subscribe((data) => {
        this.fuelDistList = data
        this.importVehiclesExcelReport(data)
        this.loaderService.display(false)
      })
  }

  primeDroupdownCheck(e) {
    this.primeValue = e.target.value

    this.selectedStartsDate = null
    this.selectedEndDate = null

    this.selectedStartsDate = ''
    this.selectedEndDate = ''

    if (this.primeValue == 'day') {
      console.log(this.primeValue)

      this.primeChevckDays = true

      this.primeChevckMonths = false
    } else {
      console.log(this.primeValue)

      this.primeChevckMonths = true

      this.primeChevckDays = false
    }
  }

  orgValueChange(currDate) {
    var monthFromSingeDay = moment(currDate).format('MM')
    var yearFromSingeDay = moment(currDate).format('YYYY')

    var monthsAsNumber = Number(monthFromSingeDay)
    var yearAsNumber = Number(yearFromSingeDay)
    console.log('yearAsNumber', yearAsNumber)
    var selectday = moment(currDate).format('YYYY-MM-DD')
    var selectday = moment(currDate).format('YYYY-MM-DD')

    this.selectedStartsDate = selectday
    this.selectedEndDate = selectday

    this.currentMonth = moment(this.selectedStartsDate).format('MMMM')

    //monthsAsNumber>5 &&
    if (yearAsNumber > 2022) {
      this.newVersionAPIS(this.selectedStartsDate, this.selectedEndDate)
    } else {
      if (monthsAsNumber < 5 && yearAsNumber < 2023) {
        this.oldVersionAPIS(this.selectedStartsDate, this.selectedEndDate)
      } else {
        this.newVersionAPIS(this.selectedStartsDate, this.selectedEndDate)
      }

      //this.oldVersionAPIS(this.selectedStartsDate, this.selectedEndDate);
    }
  }

  downloadReport() {
    this.selectedStartsDate
    this.selectedEndDate
    this.prjId

    // var startDate = moment(this.date).format("YYYY-MM-DD");
    // var endDate = moment(new Date()).add(1, 'days').format("YYYY-MM-DD");

    window.open(
      environment.apiUrl +
        'reports/getNewFuelMasterExcellReport?' +
        'prjId=' +
        this.prjId +
        '&StartsDate=' +
        this.selectedStartsDate +
        '&EndDate=' +
        this.selectedEndDate,
    )
  }

  downloadNewReport() {
    this.selectedStartsDate
    this.selectedEndDate
    this.prjId

    // var startDate = moment(this.date).format("YYYY-MM-DD");
    // var endDate = moment(new Date()).add(1, 'days').format("YYYY-MM-DD");
    window.open(
      environment.apiUrl +
        'reports/downloadNewReport?' +
        'prjId=' +
        this.prjId +
        '&StartsDate=' +
        this.selectedStartsDate +
        '&EndDate=' +
        this.selectedEndDate,
    )
  }

  getYearlyMonthsWisefuelDetails() {
    var startDate = '2022-01-01'

    var endDate = '2022-06-22'

    // getNewPuechaseDistributeMonthWiseDate

    this.http
      .get(
        environment.apiUrl +
          'reports/getYearlyMonthsWisefuelDetails?prjid=' +
          this.prjId +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate,
      )
      .subscribe((data) => {
        this.distributedata = data

        console.log('1206', this.distributedata)

        this.YearDistributeFuledata = []
        this.YearPurchaseFuledata = []
        this.YearLooseFuledata = []

        for (let i = 0; i < this.distributedata.length; i++) {
          if (this.distributedata[i]['PURCHASETYPE'] == 'Distributed') {
            this.YearDistributeFuledata.push({
              dates: this.distributedata[i]['monthNames'],
              TOTALQYT: Number(this.distributedata[i]['QTY']),
            })
          }
          if (this.distributedata[i]['PURCHASETYPE'] == 'Vehicle') {
            this.YearPurchaseFuledata.push({
              dates: this.distributedata[i]['monthNames'],
              TOTALQYT: Number(this.distributedata[i]['QTY']),
            })
          }
          if (this.distributedata[i]['PURCHASETYPE'] == 'Loose') {
            this.YearLooseFuledata.push({
              dates: this.distributedata[i]['monthNames'],
              TOTALQYT: Number(this.distributedata[i]['QTY']),
            })
          }
          console.log('YearDistributeFuledata', this.YearDistributeFuledata)
          console.log('YearPurchaseFuledata', this.YearPurchaseFuledata)
          console.log('YearLooseFuledata', this.YearLooseFuledata)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/fuel/fuelMaster.component.ts